// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import { roles } from '../context/Roles';
import { companyTypes } from '../Constants';
import { Role } from '../context/ContextWrapper';

export const deepCopy = <T>(value: T): T => {
    if (value === undefined) {
        return value;
    }
    return JSON.parse(JSON.stringify(value));
};

export const getRolesForAgreementType = (agreementType: string): Role[] => {
    const allRoles = roles(false);
    return allRoles.filter((item: any) => item.roleGroup.includes(agreementType));
};

export const sortByAgreementType = (a: string, b: string): number =>
    companyTypes.indexOf(a) - companyTypes.lastIndexOf(b);
